import { useState } from 'react'
import { connect } from 'react-redux'
import { withLocalize } from 'react-localize-redux'
import PropTypes from 'prop-types'
import { Modal } from '@material-ui/core'
import styles from './ManageTrustedUsersModalContainer.module.scss'
import ManageTrustedUsersModal from '../components/ManageTrustedUsersModal'
import { getProjectsRaw } from 'common/selectors/projects'
import { getUser } from 'common/selectors/user'
import { manageTrustedUsers } from 'common/actions/user'
import { getIsAddingEmail, getIsSubmitting } from '../selectors'
import { immutableToArray } from 'utils/system'

const ManageTrustedUsersModalContainer = props => {
  const [open] = useState(true)
  const { hideModal, projects, user, manageTrustedUsers, isAddingEmail, isSubmitting, email } =
    props

  const handleSave = data => {
    const jsonData = {}
    jsonData.userId = user.toJS()._id
    jsonData.usersToAdd = data.usersToAdd
    jsonData.unsharedUsers = data.unsharedUsers
    manageTrustedUsers(jsonData)
  }

  const projectJS = immutableToArray(projects)
  return (
    <div>
      <Modal
        open={open}
        onClose={hideModal}
        scroll='body'
        BackdropProps={{
          classes: {
            root: styles.backdrop
          }
        }}
        arial-labelledby='simple-modal-title'
        arial-desccribedby='simple-modal-description'
      >
        <div>
          <ManageTrustedUsersModal
            {...props}
            isAddingEmail={isAddingEmail}
            isSubmitting={isSubmitting}
            projects={projectJS}
            user={user}
            userMail={email}
            handleSave={handleSave}
          />
        </div>
      </Modal>
    </div>
  )
}

ManageTrustedUsersModalContainer.propTypes = {
  hideModal: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  projects: getProjectsRaw(state),
  user: getUser(state),
  isAddingEmail: getIsAddingEmail(state),
  isSubmitting: getIsSubmitting(state)
})

const mapActionsToProps = {
  manageTrustedUsers
}

export default withLocalize(
  connect(mapStateToProps, mapActionsToProps)(ManageTrustedUsersModalContainer)
)
